function ensureMessageBox(id, className) {
    let messageBox = document.getElementById(id);
    if (!messageBox) {
        messageBox = document.createElement("div");
        messageBox.id = id;
        messageBox.className = className;
        const container = document.querySelector(".max-w-full.mx-auto");
        container.insertBefore(messageBox, container.firstChild);
    }
    return messageBox;
}

function attachHoldBehavior(messageBox) {
    if (messageBox.dataset.holdBound) return;

    messageBox.dataset.holdBound = "true";
    messageBox.style.cursor = "grab";
    messageBox.style.userSelect = "none";

    const startHold = () => {
        messageBox.style.cursor = "grabbing";
        messageBox.dataset.keepVisible = "true";
        if (messageBox._hideTimer) clearTimeout(messageBox._hideTimer);
    };

    const endHold = () => {
        messageBox.style.cursor = "grab";
        if (!messageBox.dataset.keepVisible) return;
        delete messageBox.dataset.keepVisible;
        if (messageBox._hideTimer) clearTimeout(messageBox._hideTimer);
        messageBox._hideTimer = setTimeout(() => {
            messageBox.style.display = "none";
        }, getHideDelay(messageBox));
    };

    messageBox.addEventListener("mousedown", startHold);
    messageBox.addEventListener("touchstart", startHold, { passive: true });
    messageBox.addEventListener("mouseup", endHold);
    messageBox.addEventListener("mouseleave", endHold);
    messageBox.addEventListener("touchend", endHold);
    messageBox.addEventListener("touchcancel", endHold);
}

function getHideDelay(messageBox, fallback = 5000) {
    const value = Number.parseInt(messageBox.dataset.hideMs || "", 10);
    return Number.isFinite(value) && value > 0 ? value : fallback;
}

function startHideTimer(messageBox) {
    if (messageBox._hideTimer) clearTimeout(messageBox._hideTimer);
    messageBox._hideTimer = setTimeout(() => {
        messageBox.style.display = "none";
    }, getHideDelay(messageBox));
}

export function showSuccessMessage(message) {
    const messageBox = ensureMessageBox(
        "successMessage",
        "mb-4 p-4 bg-green-100 border border-green-400 text-green-700 rounded shadow-sm",
    );
    messageBox.dataset.hideMs = "10000";
    attachHoldBehavior(messageBox);
    messageBox.textContent = message;
    messageBox.style.display = "block";
    if (!messageBox.dataset.keepVisible) startHideTimer(messageBox);
}

export function showErrorMessage(message) {
    const messageBox = ensureMessageBox(
        "errorMessage",
        "mb-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded shadow-sm",
    );
    messageBox.dataset.hideMs = "30000";
    attachHoldBehavior(messageBox);
    messageBox.textContent = message;
    messageBox.style.display = "block";
    if (!messageBox.dataset.keepVisible) startHideTimer(messageBox);
}
